module.exports = __webpack_public_path__ + "img/Cement 480x480.76280145.jpg";